import { keyframes } from "@emotion/react";
import { styled } from "@mui/material";

const CircleLoader = styled('div', {
  shouldForwardProp: prop => !['color'].includes(prop)
})(({ size = 30, color, inset = '60%' }) => {
  return ({
    width: `${size}px`,
    aspectRatio: 1,
    // color,
    position: 'relative',
    '&:before, &:after': {
      content: '""',
      position: 'absolute',
      borderRadius: `${size/2}px`,
      background: 'currentColor',
      animation: `${keyframes`
        0% {
          inset: 0 ${inset} ${inset} 0;
        }
        12.5% {
          inset: 0 ${inset} 0 0;
        }
        25% {
          inset: ${inset} ${inset} 0 0;
        }
        37.5% {
          inset: ${inset} 0 0 0;
        }
        50% {
          inset: ${inset} 0 0 ${inset};
        }
        62.5% {
          inset: 0 0 0 ${inset};
        }
        75% {
          inset: 0 0 ${inset} ${inset};
        }
        87.5% {
          inset: 0 0 ${inset} 0;
        }
        100% {
          inset: 0 ${inset} ${inset} 0;
        }
      `} 2.5s infinite`,
    },
    '&:after': {
      animationDelay: '-1.25s',
    }
  })
})

export default CircleLoader;
